import React, { useEffect, useState } from 'react'
import { Button, List } from 'antd';
import styles from './subscription.module.css'
import { useNavigate,useLocation } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import SubscriptionMiddlewre from '../../store/Middlewares/SubsciptionMiddleware';
import AlertAction from '../../store/Actions/AlertActions';

function SubscriptionPlans() {

    useEffect(() => {
        getSubscription();
        getLanguage();
    }, [])

    const { state } = useLocation();
    const data = state;

    const dispatch = useDispatch()
    const { t, i18n } = useTranslation();
    //const [loading, setLoading] = useState();
    const user = useSelector(state => state.AuthReducer.user);

    const [PlanList, setPlanList] = useState([])
    const [packageName, setPackageName] = useState([])

    const getLanguage = async () => {
        try {
            const language = localStorage.getItem('@selectedLanguage');
            i18n.changeLanguage(language)
        } catch (e) {
            console.log(e)
        }
    };

    const getSubscription = () => {
        dispatch(SubscriptionMiddlewre.getSubscription())
            .then((data) => {
                setPlanList(data?.data)
            })
            .catch((e) => {
                console.log(e);
            })
    }

    
    const navigate = useNavigate()
    return (
        <div style={{ width: '100%' }}>
            <List
                dataSource={PlanList}
                grid={{
                    xs: 1,
                    sm: 2,
                    md: 2,
                    lg: 3,
                    xl: 3,
                    xxl: 3,
                }}
                renderItem={(item, index) => {
                    console.log('item', item)
                    return (
                        <div className={styles.item}>

                            <div className={styles.flexC}>
                                <h1 className={styles.heading}>{item?.package_name}</h1>
                                <h2 className={styles.sub_heading}>{item?.description}</h2>
                                {/* <h4 className={styles.text}>{item?.noOfEmp} employee</h4> */}
                            </div>
                            <div>
                                <h2 className={styles.price}>${item?.price}</h2>
                            </div>
                            <div>
                                <Button type="primary" className={styles.antdButton} onClick={() => {
                                    if (!item?.is_subscribed) {
                                        navigate('/subscription/AddCard/Payments', { state: item })
                                    }else{
                                        dispatch(AlertAction.ShowAlert({ type: "error", message: 'Already subscribed!' }))
                                    }
                                }}>
                                    {item?.is_subscribed ? t('Subscribed') : t('Subscribe Plan')}
                                </Button>
                            </div>
                        </div>
                    );
                }}
            />
        </div>
    )
}

export default SubscriptionPlans